var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.hasCommonHeader)?_c('common-header'):_vm._e(),(_vm.hasServerHeader)?_c('service-center-header'):_vm._e(),_c('div',{staticClass:"container"},[(_vm.routerAlive)?_c('router-view'):_vm._e()],1),_c('coin-popup'),_c('level-popup'),_c('common-drainage-pop'),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }